import InnerLayout from '~/components/InnerLayout';
import List from './List';
import { getStore } from '~/mobx/AppStore';
import { FC, useEffect } from 'react';
import Details from './Details';
import { observer } from 'mobx-react';
import { Candidate, Region } from '~/definitions/candidates';
import Copy from './Copy';
import { DEFAULT_REGIONS } from '~/consts/candidates';
import ElectionMenu from '~/components/ElectionMenu';

interface Props {
    selectedCandidateId: string;
    isTabContentReset: boolean;
    candidates: Candidate[];
    regions: Region[];
    selectedRegionId: string;
    isCreateMode: boolean;
    isEditMode: boolean;
    isLoadingCandidateList: boolean;
    isDisabled: boolean;
}

const Candidates: FC<Props> = (props) => {
    const selectedRegion = props.regions.find((region) => region.id === props.selectedRegionId) || DEFAULT_REGIONS[0];

    const getContent = () => {
        return (props.selectedCandidateId !== '' && !props.isTabContentReset) ||
            props.isCreateMode ||
            props.isEditMode ? (
            <>
                <Details />
                {!props.isDisabled && !props.isCreateMode && <Copy />}
            </>
        ) : (
            <List
                regions={props.regions}
                selectedRegion={selectedRegion}
                candidates={props.candidates}
                isLoadingCandidateList={props.isLoadingCandidateList}
                isDisabled={props.isDisabled}
            />
        );
    };

    return <InnerLayout leftPanel={<ElectionMenu />} content={getContent()} />;
};

const CandidatesWithStore = () => {
    const {
        regions,
        setRegions,
        setSelectedRegionId,
        candidates,
        selectedCandidateId,
        isCreateMode,
        isEditMode,
        isLoadingCandidateList,
        cancelEdit,
    } = getStore().candidateStore;
    const { isTabContentReset } = getStore().tabStore;
    const { isSettingsDisabled } = getStore().generalSettingsStore;

    const { regions: electionMenuRegions } = getStore().electionMenuStore;
    const { selectedRegionId } = getStore().regionStore;

    useEffect(() => {
        const validRegions = (electionMenuRegions ?? []).filter(
            (region): region is { id: string; name: string } & typeof region =>
                typeof region.id === 'string' && typeof region.name === 'string'
        );

        setRegions(validRegions);
        setSelectedRegionId(selectedRegionId);

        cancelEdit({ skipCandidateListReload: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRegionId]);

    return (
        <Candidates
            regions={regions}
            candidates={candidates}
            selectedCandidateId={selectedCandidateId}
            isTabContentReset={isTabContentReset}
            selectedRegionId={selectedRegionId}
            isCreateMode={isCreateMode}
            isEditMode={isEditMode}
            isLoadingCandidateList={isLoadingCandidateList}
            isDisabled={isSettingsDisabled}
        />
    );
};

export default observer(CandidatesWithStore);
